import { render, staticRenderFns } from "./Section1Widget.vue?vue&type=template&id=2f1bb1c8&lang=pug&"
import script from "./Section1Widget.vue?vue&type=script&lang=js&"
export * from "./Section1Widget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports